import { get } from 'lodash-es';
import { logger } from './logger';

const specialKeyWhitelist = ['Escape', 'ArrowLeft', 'ArrowRight'];

const isRepeating = (event) => {
  return get(event, 'originalEvent.repeat', false);
};

export const isKeyEventOnInput = () => {
  const elementTagsToIgnore = ['input', 'textarea', 'select'];
  const tagName = document.activeElement?.tagName?.toLowerCase();
  return elementTagsToIgnore.indexOf(tagName) >= 0 || document.activeElement?.getAttribute?.('contenteditable') === 'true';
};

const allowInputsForBarcodeScanSearch = () => {
  return false;
};

export const shouldAddEventKey = (event) => {
  if (!event.key) {
    return false;
  }

  if (isRepeating(event)) {
    logger.log('Ignored event with repeat on');
    return false;
  }

  if (isKeyEventOnInput(event) && !allowInputsForBarcodeScanSearch()) {
    logger.log('Ignored event for being on input');
    return false;
  }

  if (event.key.length > 1 && specialKeyWhitelist.indexOf(event.key) === -1) {
    logger.log('Ignored event because of special key');
    return false;
  }

  return true;
};
